// Selection cap shared across the modal Editor and the selected-list toggle so
// the limit stays in one place if it ever changes.
export const MAX_SELECTED = 100;
